import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';

import { Stack, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty, isEqual, map, find, cloneDeep } from 'lodash';
import {
  renderButton,
  renderIconButton,
  renderSelect,
  renderSwitch,
  renderTable,
  renderTextField
} from '../../MaterialMUIComponent';

import { ELEMENT_TYPES } from '../../../../api/AnnotationTemplates/AnnotationTemplates';
import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';
import * as mapOps from '../../../../api/Maps/map-operations';

import CenterMap from '../../CenterMap';
import MapContainerViewMap from '../../../containers/MapContainerViewMap';

import UploadFileComponent from '../../UploadFileComponent/UploadFileComponent';

const optionsEnterMap = ['Select Map', 'Link Map Shared'];

const TemplateImapsItemEdit = ({
  elementItem,
  updateAnnotationFields,
  maps,
  layers,
  updatedAnnotation,
  selectedAnnotation,
  deployEnv,
  ...rest
}) => {
  const multiMapsSchema = templateOps.getElementMultipleMaps(elementItem);
  const [optEnterMapSelected, setOptEnterMapSelected] = React.useState(optionsEnterMap[0]);

  const isMultiMap = isEqual(templateOps.getElementType(elementItem), ELEMENT_TYPES.MULTIPLEIMAPS);
  const schemaDefault = {
    nameMap: 'none',
    mapId: '',
    zoom: 6,
    heightMap: '400',
    centerMode: 'none',
    coordsCenter: [],
    coordinates: [],
    linkMap: '',
    imgMap: 'https://sd1.d3.ipsilum.com/files_uploaded/default_multiImap.jpg',
    onlyFullScreen: false
  };
  const startSchema = isMultiMap ? {} : templateOps.getElementMap(elementItem);
  const startNewSchema = !isEmpty(startSchema) ? startSchema : schemaDefault;
  const [newSchema, setNewSchema] = React.useState(startNewSchema);
  const indexMultiMap = schema =>
    multiMapsSchema.indexOf(
      find(multiMapsSchema, item => {
        const filterIndex = isEqual(optEnterMapSelected, optionsEnterMap[0])
          ? isEqual(item.mapId, schema.mapId)
          : isEqual(item.linkMap, schema.linkMap);
        return filterIndex;
      })
    );
  const mapSelected = !isEmpty(newSchema.mapId)
    ? find(maps, item => isEqual(item._id, newSchema.mapId))
    : {};

  const addMapList = (fastSchema = {}) => {
    const cloneMultiSchema = cloneDeep(multiMapsSchema);
    const cloneNewSchema = isEmpty(fastSchema) ? cloneDeep(newSchema) : cloneDeep(fastSchema);
    if (!isEqual(indexMultiMap(cloneNewSchema), -1)) {
      cloneMultiSchema.splice(indexMultiMap(cloneNewSchema), 1, cloneNewSchema);
      updateAnnotationFields(elementItem, 'multipleMaps', cloneMultiSchema);
    } else
      updateAnnotationFields(elementItem, 'multipleMaps', [...multiMapsSchema, cloneNewSchema]);
    Bert.alert('Map add/update successfuly', 'success');
  };

  const deleteMapList = () => {
    const cloneMultiSchema = cloneDeep(multiMapsSchema);
    if (!isEqual(indexMultiMap(newSchema), -1))
      cloneMultiSchema.splice(indexMultiMap(newSchema), 1);
    updateAnnotationFields(elementItem, 'multipleMaps', cloneMultiSchema);
    Bert.alert('Map remove successfuly', 'warning');
  };

  const handleOption = () => {
    if (isEqual(optEnterMapSelected, optionsEnterMap[0])) {
      setOptEnterMapSelected(optionsEnterMap[1]);
      setNewSchema({ ...schemaDefault, nameMap: '' });
    } else {
      setOptEnterMapSelected(optionsEnterMap[0]);
      setNewSchema({ ...schemaDefault, nameMap: multiMapsSchema.length + 1 });
    }
  };

  const handleMap = nameMap => {
    if (isEqual(nameMap, 'none')) {
      setNewSchema(schemaDefault);
      if (!isMultiMap) updateAnnotationFields(elementItem, 'map', schemaDefault);
    } else {
      const mapSchema = find(multiMapsSchema, item => isEqual(item.nameMap, nameMap));
      const newMap = find(maps, item => isEqual(item.name, nameMap));
      const newMapSchema = !isEmpty(mapSchema)
        ? mapSchema
        : { ...newSchema, mapId: newMap._id, nameMap, linkMap: '' };
      setNewSchema(newMapSchema);
      if (!isMultiMap) updateAnnotationFields(elementItem, 'map', newMapSchema);
    }
  };

  const handleSchemaList = nameSchema => {
    if (isEqual(nameSchema, 'New...')) setNewSchema(schemaDefault);
    else {
      const mapSchema = find(multiMapsSchema, item => isEqual(item.nameMap, nameSchema));
      if (isEmpty(mapSchema.mapId)) setOptEnterMapSelected(optionsEnterMap[1]);
      else setOptEnterMapSelected(optionsEnterMap[0]);
      setNewSchema(mapSchema);
    }
  };

  const iconsPosition = [
    {
      functionProp: () => updateAnnotationFields(elementItem, 'positionElement', 'flex-start'),
      icon: <FontAwesomeIcon icon="align-left" />,
      title: 'Align left',
      disabled: false,
      color: templateOps.getElemenPosition(elementItem) === 'flex-start' ? 'green' : 'blue'
    },
    {
      functionProp: () => updateAnnotationFields(elementItem, 'positionElement', 'center'),
      icon: <FontAwesomeIcon icon="align-justify" />,
      title: 'Center',
      disabled: false,
      color: templateOps.getElemenPosition(elementItem) === 'center' ? 'green' : 'blue'
    },
    {
      functionProp: () => updateAnnotationFields(elementItem, 'positionElement', 'flex-end'),
      icon: <FontAwesomeIcon icon="align-right" />,
      title: 'Align right',
      disabled: false,
      color: templateOps.getElemenPosition(elementItem) === 'flex-end' ? 'green' : 'blue'
    }
  ];

  const buttonsSaveRemove = [
    {
      functionProp: () => addMapList(),
      contentProp: !isEmpty(find(multiMapsSchema, item => isEqual(item.nameMap, newSchema.nameMap)))
        ? 'Update '
        : 'Add',
      disabledProp: isEmpty(newSchema.mapId) && isEmpty(newSchema.linkMap),
      colorProp: 'success',
      styleProp: {}
    },
    {
      functionProp: () => deleteMapList(),
      contentProp: 'Remove',
      disabledProp: isEmpty(
        find(multiMapsSchema, item => isEqual(item.nameMap, newSchema.nameMap))
      ),
      colorProp: 'error',
      styleProp: {}
    }
  ];

  const renderManyTextField = array =>
    map(array, item => (
      <Box
        key={`box-${templateOps.getElementOrder(elementItem)}-${item.nameSchema}`}
        sx={{
          display: 'flex',
          mb: 2,
          width: item.widthBox || '100%'
        }}
      >
        {renderTextField({
          key: `textfield-${templateOps.getElementOrder(elementItem)}-${item.nameSchema}`,
          type: item.type || 'text',
          label: item.label,
          style: { ...item.style },
          moreProps: {
            fullWidth: true,
            onChange: event => {
              setNewSchema({
                ...newSchema,
                [item.nameSchema]:
                  isEqual(item.type, 'number') && !isEqual(item.nameSchema, 'heightMap')
                    ? Number(event.target.value)
                    : event.target.value
              });
            },
            value: newSchema[item.nameSchema],
            ...item.moreProps
          }
        })}
      </Box>
    ));

  const elementsTable = [
    {
      row: 1,
      column: 0,
      isShowRow: true,
      isShowCol: true,
      showElement: true,
      rowJustifyContent: 'flex-start',
      elements: [
        renderSwitch({
          key: `fullScreen-${templateOps.getElementOrder(elementItem)}`,
          checked: newSchema.onlyFullScreen,
          onChange: event => setNewSchema({ ...newSchema, onlyFullScreen: event.target.checked }),
          labelCheck: 'Full Screen',
          labelUncheck: 'Inside Annotation'
        }),
        renderSwitch({
          key: `enabled-fullScreen-${templateOps.getElementOrder(elementItem)}`,
          checked: templateOps.getEnabledFullScreen(elementItem),
          onChange: () => {
            updateAnnotationFields(
              elementItem,
              'enabledFullScreen',
              !templateOps.getEnabledFullScreen(elementItem)
            );
          },
          labelCheck: 'Enabled full screen',
          labelUncheck: 'Disabled full screen'
        }),
        isMultiMap &&
          map(iconsPosition, iconElement =>
            renderIconButton({
              key: `iconPosition-${templateOps.getElementOrder(elementItem)}-imaps-${
                iconElement.icon
              }`,
              style: { color: iconElement.color },
              onClick: iconElement.functionProp,
              icon: iconElement.icon,
              titleTooltip: iconElement.title,
              disabled: iconElement.disabled
            })
          )
      ]
    },
    {
      row: 2,
      column: 1,
      isShowRow: true,
      isShowCol: true,
      colWidth: '100vh',
      showElement: true,
      elements: [
        <Stack
          key={`row2-column1-${templateOps.getElementOrder(elementItem)}`}
          direction="row"
          width="100%"
          display="flex"
          justifyContent="flex-start"
          mb={2}
        >
          {renderIconButton({
            key: `iconOptionMap-${templateOps.getElementOrder(elementItem)}`,
            titleTooltip: isEqual(optEnterMapSelected, optionsEnterMap[0])
              ? 'Link Map Shared'
              : 'Select Map',
            style: {
              color: 'blue',
              marginBottom: isEqual(optEnterMapSelected, optionsEnterMap[1]) ? '5%' : '0%'
            },
            onClick: () => handleOption(),
            icon: isEqual(optEnterMapSelected, optionsEnterMap[0]) ? (
              <FontAwesomeIcon icon="link" />
            ) : (
              <FontAwesomeIcon icon="map" />
            )
          })}
          {isEqual(optEnterMapSelected, optionsEnterMap[0]) &&
            renderSelect({
              key: `select-map-${templateOps.getElementOrder(elementItem)}`,
              style: {
                width: '95%',
                marginTop: '1/2%'
              },
              label: 'Maps',
              inputLabel: 'Maps',
              arrayOptions: ['none'].concat(map(maps, itemMap => itemMap.name)),
              onChange: event => handleMap(event.target.value),
              value: newSchema.nameMap
            })}
          {isEqual(optEnterMapSelected, optionsEnterMap[1]) &&
            renderManyTextField([
              { label: 'Link shared', nameSchema: 'linkMap', style: { width: '95%' } }
            ])}
        </Stack>,
        isMultiMap && (
          <UploadFileComponent
            key={`upload-file-${templateOps.getElementOrder(elementItem)}`}
            linkValueProp={newSchema.imgMap}
            handleValueLink={link => setNewSchema({ ...newSchema, imgMap: link })}
            labelProp="Image"
          />
        ),
        isEqual(optEnterMapSelected, optionsEnterMap[0]) &&
          renderManyTextField([
            { label: 'Zoom', nameSchema: 'zoom', type: 'number', style: { width: '95%' } },
            { label: 'Height', nameSchema: 'heightMap', type: 'number', style: { width: '95%' } }
          ]),
        isEqual(optEnterMapSelected, optionsEnterMap[0]) && (
          <CenterMap
            key={`centerMap-${templateOps.getElementOrder(elementItem)}-${newSchema.mapId}`}
            startCoords={newSchema.coordsCenter}
            startMode={newSchema.centerMode}
            handleCenterMap={(coords, mode) => {
              if (
                !isEqual(coords, newSchema.coordsCenter) ||
                !isEqual(mode, newSchema.centerMode)
              ) {
                setNewSchema({
                  ...newSchema,
                  centerMode: mode,
                  coordsCenter: coords
                });
                if (!isMultiMap)
                  updateAnnotationFields(elementItem, 'map', {
                    ...newSchema,
                    centerMode: mode,
                    coordsCenter: coords
                  });
              }
            }}
            map={find(maps, item => isEqual(item._id, newSchema.mapId))}
            elementToRender={{ mode: newSchema.centerMode, coords: newSchema.coordsCenter }}
            updatedAnnotation={updatedAnnotation}
            widthSelector="95%"
            isSettingsMode
            {...rest}
          />
        ),
        isEqual(optEnterMapSelected, optionsEnterMap[1]) &&
          map(
            [
              { name: 'Name map shared', nameSchema: 'nameMap', show: true },
              { name: 'Height iframe', nameSchema: 'heightMap', show: true }
            ],
            item =>
              item.show &&
              renderTextField({
                key: `textfield-${templateOps.getElementOrder(elementItem)}-${item.nameSchema}`,
                type: isEqual(item.nameSchema, 'heightMap') ? 'number' : 'text',
                label: item.name,
                style: { width: '95%', marginBottom: '2%' },
                moreProps: {
                  onChange: event => {
                    setNewSchema({
                      ...newSchema,
                      [item.nameSchema]: event.target.value.toString()
                    });
                    if (!isMultiMap)
                      updateAnnotationFields(elementItem, 'map', {
                        ...newSchema,
                        [item.nameSchema]: event.target.value.toString()
                      });
                  },
                  value: newSchema[item.nameSchema]
                }
              })
          )
      ]
    },

    {
      row: 2,
      column: 2,
      isShowRow: true,
      isShowCol: true,
      showElement: true,
      elements: [
        isMultiMap &&
          renderSelect({
            key: `selectMulti-${templateOps.getElementOrder(elementItem)}`,
            multiple: true,
            style: {
              width: '95%',
              marginTop: '1/2%'
            },
            label: 'IMaps',
            inputLabel: 'IMaps',
            arrayOptions: ['New...'].concat(map(multiMapsSchema, item => item.nameMap)),
            onChange: event => handleSchemaList(event.target.value),
            value: !isEmpty(find(multiMapsSchema, item => isEqual(item.mapId, newSchema.mapId)))
              ? [newSchema.nameMap]
              : ['New...']
          }),
        isMultiMap && (
          <Stack
            key={`ro2-column2-${templateOps.getElementOrder(elementItem)}`}
            direction="row"
            display="flex"
            justifyContent="flex-end"
            marginTop="2%"
            marginRight="2.5%"
          >
            {map(buttonsSaveRemove, (item, index) =>
              renderButton({
                key: `iconButton-mapEditor-${index}-${templateOps.getElementOrder(elementItem)}`,
                onClick: item.functionProp,
                contentButton: item.contentProp,
                disabled: item.disabledProp,
                color: item.colorProp,
                style: item.styleProp
              })
            )}
          </Stack>
        ),
        !isMultiMap && !isEmpty(mapSelected) && (
          <MapContainerViewMap
            key={`mapContainer-${templateOps.getElementOrder(elementItem)}`}
            deployEnv={deployEnv}
            baseMaps={mapOps.getLayerObjectsArray(mapSelected, layers, false)}
            layers={mapOps.getLayerObjectsArray(mapSelected, layers)}
            leafletMapId={`imaps-${mapOps.getId(mapSelected)}`}
            map={mapSelected}
            updateLocation={location => setNewSchema({ ...newSchema, zoom: location.zoom })}
            height="50vh"
            showReloadPosition={false}
          />
        ),
        !isMultiMap && !isEmpty(newSchema.linkMap) && (
          <iframe
            key={`ifram-imap-${templateOps.getElementOrder(elementItem)}`}
            src={newSchema.linkMap}
            width="100%"
            height="200px"
            align="center"
            title="mapShared"
          />
        )
      ]
    }
  ];

  return (
    <Box
      key={`main-box-editMap-${templateOps.getElementOrder(elementItem)}`}
      width="100%"
      id="main-box"
    >
      <Box
        key={`box-component-editMap-${templateOps.getElementOrder(elementItem)}`}
        width="100%"
        id="box-component"
      >
        {renderTable(elementsTable)}
      </Box>
    </Box>
  );
};
TemplateImapsItemEdit.defaultProps = {
  maps: [],
  layers: [],
  updatedAnnotation: {},
  selectedAnnotation: {},
  deployEnv: 'gmv'
};

TemplateImapsItemEdit.propTypes = {
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func.isRequired,
  maps: PropTypes.array,
  layers: PropTypes.array,
  updatedAnnotation: PropTypes.object,
  selectedAnnotation: PropTypes.object,
  deployEnv: PropTypes.string
};

export default TemplateImapsItemEdit;
